import DefaultList from "@/components/DefaultList";
import DictionaryCreator from "@/components/dictionaries/DictionaryCreator";
import DictionaryEditor from "@/components/dictionaries/DictionaryEditor";
import { PATH_DICTS_NETWORKS } from "@/constants";
import { createDictionaryLabels } from "@/containers/dictionaries/createDictionaryLabels";
import { defaultDictionaryTableFeatures } from "@/containers/dictionaries/defaultDictionaryTableFeatures";
import { Module } from "@/constants";
import { getDictionaryLabels } from "@/containers/dictionaries/getDictionaryLabels";
import { DictionaryConfig } from "@/containers/dictionaries/types";
import { readNetwork, writeNetwork } from "@/schemas/network";
import { NetworkService } from "@/services/network";
import { ReadNetwork, WriteNetwork } from "@/types/network";
import { Network } from "lucide-react";

const id = Module.Networks;
const path = PATH_DICTS_NETWORKS;
const ns = "networks";

const config: DictionaryConfig<ReadNetwork, WriteNetwork> = {
  id,
  ns,
  service: NetworkService,
  path,
  labels: createDictionaryLabels(ns),
  getLabels: getDictionaryLabels,
  schema: writeNetwork,
  defaultValues: { name: "" },
  Icon: Network,
  List: () => (
    <DefaultList<ReadNetwork>
      schema={readNetwork}
      name={ns}
      fetchList={NetworkService.getList}
      pathBuilder={(row) => `${path}/${row.id}`}
      tableFeatures={{
        ...defaultDictionaryTableFeatures,
        exportSettings: { moduleName: Module.Networks },
      }}
    />
  ),
  Creator: DictionaryCreator,
  Editor: DictionaryEditor,
};

export default config;
